var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found hero is-medium is-white"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"has-text-centered"},[_c('div',{staticClass:"columns is-vcentered"},[_c('div',{staticClass:"column has-text-centered"},[_c('h1',{staticClass:"parallax-hero-title dark-text is-size-1"},[_vm._v("404")])])])])])])
}]

export { render, staticRenderFns }